export default __webpack_public_path__ + "static/media/logo.a057ce90.png";